/**
 * Ghost Product Selector JavaScript
 *
 * Handles dropdown selection, product matching, and cart addition
 * for Shopify ghost products with glass configuration options.
 */

(function () {
  "use strict";

  // Wait for DOM to be ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    const mappingDataElement = document.getElementById("variant-mapping-data");

    if (!mappingDataElement) {
      console.error("Ghost Product Selector: Mapping data not found");
      return;
    }

    let mappingData;
    try {
      mappingData = JSON.parse(mappingDataElement.textContent);
    } catch (e) {
      console.error("Ghost Product Selector: Invalid JSON in mapping data", e);
      return;
    }

    // Support both compact (m) and legacy (mappings) formats
    var rawMappings = mappingData.m || mappingData.mappings;
    if (!rawMappings || !Array.isArray(rawMappings)) {
      console.error("Ghost Product Selector: Invalid mapping data structure");
      return;
    }
    // Normalize all formats to standard objects
    // Compact format: array of pipe-delimited strings "front|left|right|back|handle|price|height|flow"
    // Legacy format: array of objects with full or short keys
    // Glass abbreviation map: C=crystal, B=black, S=standard-clear, L=clear
    var glassMap = {
      C: "crystal",
      B: "black",
      S: "standard-clear",
      L: "clear",
    };
    // Flow abbreviation map: I=internal, E=external
    var flowMap = { I: "internal", E: "external" };
    function expandGlass(v) {
      return glassMap[v] || v;
    }
    function expandFlow(v) {
      return flowMap[v] || v;
    }

    mappingData.mappings = rawMappings.map(function (item) {
      if (typeof item === "string") {
        // Pipe-delimited string: front|left|right|back|handle|price|height|flow
        var parts = item.split("|");
        return {
          front: expandGlass(parts[0] || ""),
          left: expandGlass(parts[1] || ""),
          right: expandGlass(parts[2] || ""),
          back: expandGlass(parts[3] || ""),
          handle: parts[4] || "",
          price: parts[5] || "",
          height: parts[6] || "",
          flow: expandFlow(parts[7] || ""),
        };
      }
      // Object format (legacy)
      return {
        front: item.front || item.f || "",
        left: item.left || item.l || "",
        right: item.right || item.r || "",
        back: item.back || item.b || "",
        handle: item.handle || item.h || "",
        price: item.price || item.p || "",
        height: item.height || item.ht || "",
        flow: item.flow || item.fl || "",
      };
    });

    // Get DOM elements
    const selects = {
      front: document.getElementById("front-glass"),
      left: document.getElementById("left-glass"),
      right: document.getElementById("right-glass"),
      back: document.getElementById("back-glass"),
      height: document.getElementById("height-selector"),
      flow: document.getElementById("flow-selector"),
    };

    const addToCartBtn = document.getElementById("add-selected-product");

    // Price display - use custom ghost product price element
    const priceElement = document.querySelector(".ghost-product-price__text");
    const priceContainer = document.querySelector(".ghost-product-price");

    if (!addToCartBtn) {
      console.error("Ghost Product Selector: Required elements not found");
      return;
    }

    // Optional status div (for error messages only)
    const statusDiv = document.getElementById("product-match-status");

    // Populate dropdown options dynamically from parsed mapping data
    function getUniqueValues(field) {
      var seen = {};
      var values = [];
      mappingData.mappings.forEach(function (m) {
        var v = m[field];
        if (v && !seen[v]) {
          seen[v] = true;
          values.push(v);
        }
      });
      return values;
    }

    function toDisplayName(value) {
      return value
        .split("-")
        .map(function (w) {
          return w.charAt(0).toUpperCase() + w.slice(1);
        })
        .join(" ");
    }

    ["front", "left", "right", "back"].forEach(function (field) {
      var select = selects[field];
      if (!select) return;
      var values = getUniqueValues(field);
      while (select.options.length > 1) select.remove(1);
      values.forEach(function (val) {
        var opt = document.createElement("option");
        opt.value = val;
        opt.textContent = toDisplayName(val);
        select.appendChild(opt);
      });
    });

    if (selects.height) {
      var heightValues = getUniqueValues("height");
      heightValues.sort(function (a, b) {
        return parseFloat(a) - parseFloat(b);
      });
      while (selects.height.options.length > 1) selects.height.remove(1);
      if (heightValues.length > 0) {
        heightValues.forEach(function (val) {
          var opt = document.createElement("option");
          opt.value = val;
          opt.textContent = val + '"';
          selects.height.appendChild(opt);
        });
        var heightWrapper = document.getElementById("height-selector-wrapper");
        if (heightWrapper) heightWrapper.style.display = "";
      }
    }

    if (selects.flow) {
      var flowValues = getUniqueValues("flow");
      while (selects.flow.options.length > 1) selects.flow.remove(1);
      if (flowValues.length > 0) {
        flowValues.forEach(function (val) {
          var opt = document.createElement("option");
          opt.value = val;
          opt.textContent = toDisplayName(val);
          selects.flow.appendChild(opt);
        });
        var flowWrapper = document.getElementById("flow-selector-wrapper");
        if (flowWrapper) flowWrapper.style.display = "";
      }
    }

    // Determine which optional selectors are active based on actual data
    const hasHeightSelector =
      selects.height !== null && selects.height.options.length > 1;
    const hasFlowSelector =
      selects.flow !== null && selects.flow.options.length > 1;

    // Overflow overlay: inject into image container (avoids breaking layout)
    const overflowConfig = document.getElementById("overflow-overlay-config");
    var overflowOverlay = null;
    var overflowOverlayImg = null;

    function initOverflowOverlay() {
      if (!hasFlowSelector || !overflowConfig) return;

      // image slider = .mc-main-product__content of the first child
      var container = document.querySelector(
        ".mc-main-product__image-slider--main",
      );
      if (!container) return;

      if (!overflowOverlay) {
        // parent container position: relative if not set
        if (getComputedStyle(container).position === "static") {
          container.style.position = "relative";
        }

        // Wrapper div (.overflow-overlay) — CSS handle absolute position
        overflowOverlay = document.createElement("div");
        overflowOverlay.className = "overflow-overlay";
        overflowOverlay.id = "overflow-overlay";
        overflowOverlay.setAttribute("aria-hidden", "true");

        // Badge (Internal/External label)
        var badge = document.createElement("div");
        badge.id = "overflow-overlay-badge";
        badge.textContent = "Overflow";

        // Image
        overflowOverlayImg = document.createElement("img");
        overflowOverlayImg.id = "overflow-overlay-img";
        overflowOverlayImg.alt = "";
        overflowOverlayImg.setAttribute("role", "presentation");

        // badge on top, image on bottom (flexbox column)
        overflowOverlay.appendChild(badge);
        overflowOverlay.appendChild(overflowOverlayImg);
        container.appendChild(overflowOverlay);
      }
    }

    function updateOverflowOverlay() {
      if (
        !hasFlowSelector ||
        !overflowOverlay ||
        !overflowOverlayImg ||
        !overflowConfig
      )
        return;

      var flowValue = selects.flow ? selects.flow.value.toLowerCase() : "";

      // Use URL from config if available, otherwise use fallback
      var internalUrl =
        overflowConfig.getAttribute("data-internal-url") ||
        "https://cdn.shopify.com/s/files/1/0583/4276/8686/files/Internal_Overflow.jpg?v=1773291515";
      var externalUrl =
        overflowConfig.getAttribute("data-external-url") ||
        "https://cdn.shopify.com/s/files/1/0583/4276/8686/files/External_Overflow.jpg?v=1773291518";

      var badge = document.getElementById("overflow-overlay-badge");

      if (flowValue === "internal") {
        overflowOverlayImg.src = internalUrl;
        overflowOverlayImg.alt = "Internal overflow";
        if (badge) badge.textContent = "Internal";
        overflowOverlay.classList.add("is-visible");
        overflowOverlay.setAttribute("aria-hidden", "false");
      } else if (flowValue === "external") {
        overflowOverlayImg.src = externalUrl;
        overflowOverlayImg.alt = "External overflow";
        if (badge) badge.textContent = "External";
        overflowOverlay.classList.add("is-visible");
        overflowOverlay.setAttribute("aria-hidden", "false");
      } else {
        overflowOverlay.classList.remove("is-visible");
        overflowOverlayImg.src = "";
        overflowOverlay.setAttribute("aria-hidden", "true");
      }
    }

    let selectedProductHandle = null;
    let selectedProductData = null;

    /**
     * Format price for display
     */
    function formatPrice(price) {
      if (!price || price === "0" || price === "") {
        return "Choose all options to see price.";
      }
      const numPrice = parseFloat(price);
      if (isNaN(numPrice)) {
        return "Choose all options to see price.";
      }
      return "$" + numPrice.toFixed(2);
    }

    /**
     * Update price display
     */
    function updatePriceDisplay(match) {
      if (priceElement) {
        if (match && match.price) {
          priceElement.textContent = formatPrice(match.price);
          if (priceContainer) {
            priceContainer.classList.add("price-active");
          }
        } else {
          priceElement.textContent = "Choose all options to see price.";
          if (priceContainer) {
            priceContainer.classList.remove("price-active");
          }
        }
      }
    }

    /**
     * Extracts the core filename from a Shopify CDN image URL.
     * Strips size suffixes like _100x, _5000x5000 etc. for clean comparison.
     */
    function extractImageFilename(url) {
      if (!url) return null;
      try {
        var pathname = new URL(url, window.location.origin).pathname;
        var filename = pathname.split("/").pop();
        return filename.replace(
          /_(\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(\.|$)/g,
          "$2",
        );
      } catch (e) {
        return null;
      }
    }

    /**
     * Slides the main image carousel to the variant's featured media.
     * Uses two matching strategies:
     *   1. Match by featured_media_id (data-media-id attribute on slides)
     *   2. Fallback: match by featured_image_src (compare against slide image URLs)
     */
    function updateImageSlider(variant) {
      if (!variant) return;

      var mainSwiperElement = document.querySelector(
        ".mc-main-product__image-slider--main",
      );
      if (!mainSwiperElement || !mainSwiperElement._swiperInstance) return;

      var swiperInstance = mainSwiperElement._swiperInstance;
      var slides = mainSwiperElement.querySelectorAll(".swiper-slide");
      var targetIndex = -1;

      // Strategy 1: Match by featured_media_id (Shopify Ajax API returns featured_media object)
      var mediaId = variant.featured_media ? variant.featured_media.id : null;
      if (
        mediaId == null &&
        variant.featured_image &&
        variant.featured_image.id
      ) {
        mediaId = variant.featured_image.id;
      }

      if (mediaId) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute("data-media-id") == mediaId) {
            targetIndex = i;
            break;
          }
        }
      }

      // Strategy 2: Fallback to matching by image src
      var imageSrc = variant.featured_image ? variant.featured_image.src : null;
      if (targetIndex === -1 && imageSrc) {
        var variantImageFile = extractImageFilename(imageSrc);

        if (variantImageFile) {
          for (var j = 0; j < slides.length; j++) {
            var slideImg = slides[j].querySelector("img");
            if (slideImg && slideImg.src) {
              var slideImageFile = extractImageFilename(slideImg.src);
              if (slideImageFile && slideImageFile === variantImageFile) {
                targetIndex = j;
                break;
              }
            }
          }
        }
      }

      // Slide to the matched index if found
      if (targetIndex !== -1) {
        swiperInstance.slideTo(targetIndex);
      }
    }

    /**
     * Find matching product based on selections
     */
    async function findMatchingProduct() {
      const selections = {
        front: selects.front ? selects.front.value : "",
        left: selects.left ? selects.left.value : "",
        right: selects.right ? selects.right.value : "",
        back: selects.back ? selects.back.value : "",
        height: selects.height ? selects.height.value : "",
        flow: selects.flow ? selects.flow.value : "",
      };

      // Check if all required fields are selected
      const requiredFields = [
        selections.front,
        selections.left,
        selections.right,
        selections.back,
      ];
      if (hasHeightSelector) {
        requiredFields.push(selections.height);
      }
      if (hasFlowSelector) {
        requiredFields.push(selections.flow);
      }
      const allSelected = requiredFields.every((val) => val !== "");

      if (!allSelected) {
        selectedProductHandle = null;
        selectedProductData = null;
        addToCartBtn.disabled = true;
        updatePriceDisplay(null);
        updateOverflowOverlay();
        return;
      }

      // Find matching product in mapping
      const match = mappingData.mappings.find((mapping) => {
        const glassMatch =
          mapping.front === selections.front &&
          mapping.left === selections.left &&
          mapping.right === selections.right &&
          mapping.back === selections.back;

        // If height selector exists, also match height
        let heightMatch = true;
        if (hasHeightSelector) {
          const mappingHeight = mapping.height || "";
          heightMatch = mappingHeight === selections.height;
        }

        // If flow selector exists, also match flow
        let flowMatch = true;
        if (hasFlowSelector) {
          const mappingFlow = mapping.flow || "";
          flowMatch = mappingFlow === selections.flow;
        }

        return glassMatch && heightMatch && flowMatch;
      });

      if (match) {
        selectedProductHandle = match.handle;
        selectedProductData = match;
        updatePriceDisplay(match);

        // Fetch product data to check availability and update slider
        try {
          const productResponse = await fetch(`/products/${match.handle}.js`);
          if (productResponse.ok) {
            const product = await productResponse.json();
            if (product.variants && product.variants.length > 0) {
              const availableVariant = product.variants.find((v) => v.available);
              const variant = availableVariant || product.variants[0];
              
              updateImageSlider(variant);
              
              if (availableVariant) {
                addToCartBtn.disabled = false;
                const btnText = addToCartBtn.querySelector(".btn-text");
                if (btnText) btnText.textContent = "Add to Cart";
              } else {
                addToCartBtn.disabled = true;
                const btnText = addToCartBtn.querySelector(".btn-text");
                if (btnText) btnText.textContent = "Sold Out";
              }
            } else {
              addToCartBtn.disabled = true;
            }
          } else {
            addToCartBtn.disabled = true;
          }
        } catch (e) {
          console.error("Failed to fetch product data", e);
          addToCartBtn.disabled = true;
        }
      } else {
        selectedProductHandle = null;
        selectedProductData = null;
        addToCartBtn.disabled = true;
        const btnText = addToCartBtn.querySelector(".btn-text");
        if (btnText) btnText.textContent = "Add to Cart";
        updatePriceDisplay(null);
      }
      updateOverflowOverlay();
    }

    // Add event listeners to all selects (including height if it exists)
    Object.values(selects).forEach((select) => {
      if (select) {
        select.addEventListener("change", findMatchingProduct);
      }
    });

    /**
     * Add selected product to cart
     */
    async function addToCart() {
      if (!selectedProductHandle) {
        alert("Please select a valid product combination");
        return;
      }

      // Disable button during request
      addToCartBtn.disabled = true;
      const btnText = addToCartBtn.querySelector(".btn-text");
      const btnLoading = addToCartBtn.querySelector(".btn-loading");

      if (btnText) btnText.style.display = "none";
      if (btnLoading) btnLoading.style.display = "inline";

      try {
        // Fetch the product by handle to get its ID and variants
        const productResponse = await fetch(
          `/products/${selectedProductHandle}.js`,
        );

        if (!productResponse.ok) {
          throw new Error(`Product not found: ${productResponse.status}`);
        }

        const product = await productResponse.json();

        if (!product.variants || product.variants.length === 0) {
          throw new Error("Product has no variants");
        }

        // Get first available variant (or you can add variant selection logic)
        const variant =
          product.variants.find((v) => v.available) || product.variants[0];

        if (!variant) {
          throw new Error("No available variants");
        }

        // Add to cart using Shopify Cart API
        const cartResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: variant.id,
                quantity: 1,
              },
            ],
          }),
        });

        if (!cartResponse.ok) {
          const errorData = await cartResponse.json().catch(() => ({}));
          throw new Error(errorData.description || "Failed to add to cart");
        }

        const cartData = await cartResponse.json();

        // Success - cart added
        await updateCartDrawer();

        // Reset button after short delay
        setTimeout(() => {
          if (btnText) btnText.style.display = "inline";
          if (btnLoading) btnLoading.style.display = "none";
          addToCartBtn.disabled = false;
        }, 1000);
      } catch (error) {
        console.error("Error adding to cart:", error);

        if (statusDiv) {
          statusDiv.textContent = `Error: ${error.message || "Failed to add to cart. Please try again."}`;
          statusDiv.className = "status-message error";
        }

        // Reset button
        if (btnText) btnText.style.display = "inline";
        if (btnLoading) btnLoading.style.display = "none";
        addToCartBtn.disabled = false;
      }
    }

    /**
     * Update the cart drawer via Section Rendering API
     */
    async function updateCartDrawer() {
      try {
        const response = await fetch("/?section_id=cart-drawer");
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const newCartDrawer = doc.querySelector("cart-drawer");
        const existingCartDrawer = document.querySelector("cart-drawer");

        if (newCartDrawer && existingCartDrawer) {
          existingCartDrawer.innerHTML = newCartDrawer.innerHTML;
          existingCartDrawer.classList.remove("is-empty");
          existingCartDrawer.classList.add("active");

          if (typeof existingCartDrawer.open === "function") {
            existingCartDrawer.open();
          }
        }
      } catch (error) {
        console.error("Error updating cart drawer:", error);
      }
    }

    // Add click handler to button
    addToCartBtn.addEventListener("click", addToCart);

    // Auto-select the first available combination
    if (mappingData && mappingData.mappings && mappingData.mappings.length > 0) {
      const firstMatch = mappingData.mappings[0];
      if (selects.front && firstMatch.front) selects.front.value = firstMatch.front;
      if (selects.left && firstMatch.left) selects.left.value = firstMatch.left;
      if (selects.right && firstMatch.right) selects.right.value = firstMatch.right;
      if (selects.back && firstMatch.back) selects.back.value = firstMatch.back;
      if (hasHeightSelector && selects.height && firstMatch.height) selects.height.value = firstMatch.height;
      if (hasFlowSelector && selects.flow && firstMatch.flow) selects.flow.value = firstMatch.flow;
    }

    // Initial check and price display setup
    initOverflowOverlay();
    updatePriceDisplay(null);
    findMatchingProduct();
  }
})();
